import * as React from 'react'
import { H1 } from '../../../../common/src/components/core'

export default function OperatorsDetail() {
  return (
    <div>
      <H1>Operators</H1>
    </div>
  )
}
